// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"_1x4Aw7rxIxpxgUdqZrAdLd","controls":"_12srkEeGOJMiFdnfifQS-z","add":"_3LrN8ZuS1HLSzfBz6BUgeT","cancel":"_3fVMdrSJuUsCuggu_-wps"};